/** Erreur d'API normalisée : corps contractualisé (`ApiErrorBody` de l'OpenAPI), `toApiError` y convertit TOUT échec. */
import { ErrorCode } from '@/api/generated/types.gen';

export type ApiErrorParams = Readonly<Record<string, string | number>>;

const ERROR_CODES: ReadonlySet<string> = new Set<string>(Object.values(ErrorCode));

/** Code connu de CE front (un code plus récent que le bundle ⇒ false). */
export function isErrorCode(value: unknown): value is ErrorCode {
  return typeof value === 'string' && ERROR_CODES.has(value);
}

export class ApiError extends Error {
  readonly statusCode: number;

  readonly statusMessage: string;

  readonly body: unknown;

  /** `message` fabriqué depuis le statut HTTP (« 502 Bad Gateway ») : à ne pas montrer tel quel. */
  readonly synthesized: boolean;

  /** Code stable du corps Hello-Back ; null hors corps Hello ou code inconnu. */
  readonly code: ErrorCode | null;

  readonly params: ApiErrorParams | null;

  constructor(
    statusCode: number,
    statusMessage: string,
    message: string,
    body?: unknown,
    synthesized = false,
    code: ErrorCode | null = null,
    params: ApiErrorParams | null = null,
  ) {
    super(message);
    this.name = 'ApiError';
    this.statusCode = statusCode;
    this.statusMessage = statusMessage;
    this.body = body;
    this.synthesized = synthesized;
    this.code = code;
    this.params = params;
  }
}

export function isApiError(error: unknown): error is ApiError {
  return error instanceof ApiError;
}
